import React, {Component} from 'react';
// import PostMessageService from "./services/postMessageService"; // must be imported at the beginning.
import Context from './AppModule/Context';
import WhiteLabelContextProvider from './screens/ExpertHome/WhiteLabelContextProvider';

import Main from './AppModule/Main';
import storageService from './services/storageService';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storageLoaded: false,
    };
  }

  async componentDidMount() {
    if (storageService.initSyncStorage) {
      await storageService.initSyncStorage(() => {
        this.setState({
          storageLoaded: true,
        });
      });
    } else {
      this.setState({
        storageLoaded: true,
      });
    }
  }
  render() {
    return (
      <WhiteLabelContextProvider>
        <Context>{this.state.storageLoaded && <Main />}</Context>
      </WhiteLabelContextProvider>
    );
  }
}

export default App;
